import { DatePipe } from '@angular/common';
import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { DataService } from 'src/app/services/data.service';
import { ServicecallService } from 'src/app/services/servicecall.service';
import { DeviceSwapModalComponent } from 'src/app/shared/components/dover/device-swap-modal/device-swap-modal.component';
import { EntitiesServiceService } from '../../../../../services/entities-service.service';

@Component({
  selector: 'app-device',
  templateUrl: './device.component.html',
  styleUrls: ['./device.component.css']
})
export class DeviceComponent implements OnInit, OnChanges, OnDestroy {

  @Input() entityId: any;
  @Input() uniqueId: any;
  @Input() widgetData: any;
  @Input() entityDetails: any;
  isError: boolean = false;
  isloader: boolean = false;
  deviceDetail: any;
  sourceTimestamp: any;

  private _subscription: Subscription;
  private _startTime: any = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0, 999);;
  private _intervalTimer: any;
  private _endTime: any;
  private _afterClosedSubscription: Subscription;
  private _attributeDataSubscription: Subscription;

  
  constructor(private _dialog: MatDialog, private _service: EntitiesServiceService, private _sharedService: ServicecallService, private _datePipe: DatePipe, private _dataSer: DataService) {
    this._subscription = _dataSer.events.subscribe((res: any) => {
      if (res.name === 'siteChanged' || res.name === 'apiRefresh') {
        this._getDeviceDetails();
      }
    });
  }

  ngOnInit(): void {
  }

  ngOnChanges(): void {
      this._getDeviceDetails();
  }
  deviceSwap() {
    const item = {
      entityName: this.uniqueId, entityId: this.entityId, deviceId: this.deviceDetail?.deviceId, deviceName: this.deviceDetail?.deviceName, siteId: this.deviceDetail?.siteId, Battery
        : this.deviceDetail?.attributeValue
    }
    let dialogRef = this._dialog.open(DeviceSwapModalComponent, {
      // height:"700px",
      width: '50%',
      disableClose: true,
      data: { msg: 'map', deviceDetails: item }
    });
    this._afterClosedSubscription = dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this._getDeviceDetails();
      }
    });
  }

  ngOnDestroy(): void {
    this._subscription?.unsubscribe();
    this._afterClosedSubscription?.unsubscribe();
    this._attributeDataSubscription?.unsubscribe();
    this._clearTimer();
  }

  private _refreshApi() {
    if (+this.widgetData?.refreshRate) {
      this._clearTimer();
      this._intervalTimer = setInterval(() => {
        this._getDeviceDetails();
      }, +this.widgetData?.refreshRate);
      this.isError = false;
    }
  }

  private _clearTimer() {
    if (this._intervalTimer) {
      clearInterval(this._intervalTimer);
    }
  }

  private _getDeviceDetails() {
    const reqData = {
      from: this._datePipe.transform(this._startTime, 'yyyy-MM-ddTHH:mm:ssZZ'),
      to: this._datePipe.transform(this._endTime ? this._endTime : Date.now(), 'yyyy-MM-ddTHH:mm:ssZZ'),
      entityId: this.entityId,
      siteId: this._sharedService.getSiteId()
    }

    this._attributeDataSubscription = this._service.attributeData(reqData).subscribe(
      {
        next: (result: any) => {
          if (result.status && result.response.data?.length) {
            this.deviceDetail = result?.response?.data?.find((item: any) => item.attributeName === "Battery");
            this.sourceTimestamp = this.deviceDetail?.sourceTimestamp ? this._sharedService.getLastSeenFormat(this.deviceDetail?.sourceTimestamp) : null;
          } else {
            this.deviceDetail = {};
          }
          this.isloader = false;
          this._refreshApi();
        },
        error: (error) => {
          if (error) {
            this.isloader = false;
            this.isError = true;
            this._refreshApi();
          }
        }
      }
    )
  }
}
